export default __webpack_public_path__ + "static/media/gmx_logo.59a2af6c.svg";